export const environment = {
    production: true,
    configFile: 'assets/environment.json'
};
